export default {
  "industry_011000": "011000 - 瓜菜、花卉及其他非多年生農作物的種植",
  "industry_012000": "012000 - 水果、藥用與飲料作物及其他多年生農作物的種植",
  "industry_013000": "013000 - 植物的繁殖",
  "industry_014100": "014100 - 家畜的飼養",
  "industry_014200": "014200 - 飼養家禽及採蛋",
  "industry_014900": "014900 - 其他動物的飼養",
  "industry_015000": "015000 - 農牧混合",
  "industry_016000": "016000 - 農業輔助活動及農作物收成後處理活動",
  "industry_017000": "017000 - 狩獵、捕捉及相關服務活動",
  "industry_020000": "020000 - 林業活動",
  "industry_031000": "031000 - 捕魚",
  "industry_032000": "032000 - 水產養殖",
  "industry_050000": "050000 - 煤和褐煤的採掘",
  "industry_060000": "060000 - 原油及天然氣的開採",
  "industry_070000": "070000 - 金屬礦的採掘",
  "industry_080000": "080000 - 採石及其他非金屬礦的採掘",
  "industry_090000": "090000 - 礦物開採輔助服務活動",
  "industry_101100": "101100 - 豬油及動物油的熬製",
  "industry_101200": "101200 - 屠宰",
  "industry_101300": "101300 - 肉類的醃製",
  "industry_101400": "101400 - 屠宰業副產品的製造及加工(皮革的鞣製和修整除外)",
  "industry_102000": "102000 - 魚類、甲殼類及軟體類動物食品的加工及醃製",
  "industry_103000": "103000 - 蔬果類食品的加工及醃製",
  "industry_104000": "104000 - 動植物油脂的製造",
  "industry_105000": "105000 - 乳類製品的製造",
  "industry_106101": "106101 - 豆腐的製造",
  "industry_106199": "106199 - 其他穀物磨粉製品的製造",
  "industry_106200": "106200 - 澱粉及澱粉製品的製造",
  "industry_107100": "107100 - 烤烘食品的製造",
  "industry_107200": "107200 - 糖的製煉",
  "industry_107300": "107300 - 可可、朱古力及糖果的製造",
  "industry_107400": "107400 - 粉麵及同類穀粉製品的製造",
  "industry_107500": "107500 - 預製膳食的製造",
  "industry_107901": "107901 - 生雪的製造(乾冰除外)",
  "industry_107902": "107902 - 製茶",
  "industry_107903": "107903 - 咖啡製品的製造",
  "industry_107904": "107904 - 食用香料、醬油及調味品的製造",
  "industry_107999": "107999 - 其他雜項食品的製造",
  "industry_108000": "108000 - 動物飼料的製造",
  "industry_110100": "110100 - 啤酒的釀製",
  "industry_110200": "110200 - 非啤酒酒類的製造",
  "industry_110300": "110300 - 汽水的製造；礦泉水及其他非酒類飲品的製造",
  "industry_120000": "120000 - 煙草製品的製造",
  "industry_131101": "131101 - 鬈曲",
  "industry_131102": "131102 - 紡棉紗",
  "industry_131103": "131103 - 紡毛紗",
  "industry_131104": "131104 - 紡合成纖維紗",
  "industry_131199": "131199 - 其他紡紗",
  "industry_131201": "131201 - 梭織棉布",
  "industry_131202": "131202 - 梭織毛布",
  "industry_131203": "131203 - 梭織絲綢",
  "industry_131204": "131204 - 梭織合成纖維布",
  "industry_131299": "131299 - 梭織混紡織物及其他紡織布",
  "industry_131301": "131301 - 布料印花",
  "industry_131302": "131302 - 成衣印花",
  "industry_131303": "131303 - 紗線漂染",
  "industry_131304": "131304 - 梭織布料漂染",
  "industry_131305": "131305 - 針織布料漂染",
  "industry_131306": "131306 - 成衣漂染",
  "industry_131307": "131307 - 成衣洗水(不包括衣服洗熨)",
  "industry_131399": "131399 - 紡織品的其他整理",
  "industry_139101": "139101 - 針織或鉤針編織棉布",
  "industry_139102": "139102 - 針織或鉤針編織毛布",
  "industry_139199": "139199 - 針織或鉤針編織其他布料",
  "industry_139201": "139201 - 帆布製品的製造",
  "industry_139202": "139202 - 床上用品的製造",
  "industry_139203": "139203 - 船帆及旗幟的製造",
  "industry_139204": "139204 - 打鈕門、鈒骨及壓褶",
  "industry_139205": "139205 - 窗簾或帳幔的剪裁及車縫",
  "industry_139206": "139206 - 印刷用絲網的製造(紡織品印花除外)",
  "industry_139207": "139207 - 絲帶及布帶切割(梭織標籤及窄幅布條除外)",
  "industry_139299": "139299 - 其他紡織製成品(服裝除外)的製造",
  "industry_139300": "139300 - 地氈及圍氈的製造",
  "industry_139401": "139401 - 魚網的製造",
  "industry_139402": "139402 - 繩的製造",
  "industry_139403": "139403 - 鞋帶的製造",
  "industry_139404": "139404 - 合股線的製造",
  "industry_139500": "139500 - 梭織標籤(花邊、絲帶、飾帶、繩、合股線及索具除外)",
  "industry_139600": "139600 - 刺繡品的製造",
  "industry_139700": "139700 - 層壓布的製造",
  "industry_139900": "139900 - 其他雜項紡織品的製造",
  "industry_141101": "141101 - 外衣的縫製(皮革衣服、雨衣及直接由紗線原件針織的衣物除外)",
  "industry_141102": "141102 - 裁縫(不設工場的裁縫店除外)",
  "industry_141103": "141103 - 雨衣的縫製",
  "industry_141104": "141104 - 內衣及睡衣的縫製",
  "industry_141105": "141105 - 皮革衣服的縫製",
  "industry_141199": "141199 - 其他衣物的縫製",
  "industry_141901": "141901 - 手套的製造(塑膠及橡膠手套除外)",
  "industry_141902": "141902 - 帽類的製造(草帽與塑膠、金屬及玻璃纖維頭盔除外)",
  "industry_141903": "141903 - 腰帶的製造",
  "industry_141904": "141904 - 領帶圍巾的製造",
  "industry_141999": "141999 - 其他雜項服裝製品的製造",
  "industry_142000": "142000 - 毛皮製品的製造",
  "industry_143100": "143100 - 針織或鉤針編織襪(包括各類質料)的製造",
  "industry_143200": "143200 - 針織或鉤針編織外衣(非針織衣服、雨衣及皮革衣服除外)的製造",
  "industry_143300": "143300 - 針織或鉤針編織內衣的製造",
  "industry_151100": "151100 - 皮革鞣製和修整、毛皮修整與染色的製造及加工",
  "industry_151200": "151200 - 行李箱及手袋的製造(塑膠購物袋除外)",
  "industry_151901": "151901 - 真皮或非金屬錶帶的製造",
  "industry_151999": "151999 - 其他雜項皮革及人造皮製品的製造(鞋類及服裝製品除外)",
  "industry_152000": "152000 - 鞋類製造",
  "industry_161000": "161000 - 鋸木及鉋木",
  "industry_162100": "162100 - 雙面板及鑲板木料的製造",
  "industry_162200": "162200 - 木製容器的製造(樟木匣除外)",
  "industry_162901": "162901 - 木製家庭用品、首飾盒或其他物品的製造",
  "industry_162902": "162902 - 藤製材料及物品的製造",
  "industry_162903": "162903 - 竹製材料及物品的製造",
  "industry_162904": "162904 - 草製材料及物品的製造",
  "industry_162905": "162905 - 水松材料及物品的製造",
  "industry_170100": "170100 - 紙漿、紙張及紙板的製造",
  "industry_170201": "170201 - 紙盒的製造",
  "industry_170202": "170202 - 紙袋的製造",
  "industry_170901": "170901 - 元寶衣紙的製造",
  "industry_170902": "170902 - 紙筒的製造",
  "industry_170903": "170903 - 紙燈籠的製造",
  "industry_170904": "170904 - 紙製文具的製造",
  "industry_170905": "170905 - 廁紙、紙巾及紙尿片的製造",
  "industry_170906": "170906 - 牆紙的製造",
  "industry_170999": "170999 - 其他雜項紙及紙板製品的製造",
  "industry_181100": "181100 - 印刷",
  "industry_181201": "181201 - 書籍釘裝",
  "industry_181202": "181202 - 印刷版製作、版面構圖及排字(設計除外)",
  "industry_181299": "181299 - 其他印刷及有關活動",
  "industry_182000": "182000 - 已儲錄資料媒體的複製",
  "industry_190100": "190100 - 瀝青的製造",
  "industry_190200": "190200 - 石油精煉",
  "industry_190900": "190900 - 其他焦煤和精煉石油產品的製造",
  "industry_201101": "201101 - 化學品的製造",
  "industry_201102": "201102 - 染料的製造",
  "industry_201103": "201103 - 顏料混合",
  "industry_201200": "201200 - 化肥及氮化合物的製造",
  "industry_201300": "201300 - 初級塑料及合成橡膠的製造",
  "industry_202100": "202100 - 殺蟲劑和其他農用化學製品的製造",
  "industry_202200": "202200 - 油漆、清漆及同類塗料、印刷油墨及桐油灰的製造",
  "industry_202301": "202301 - 化妝品、香水及衛浴用劑的製造",
  "industry_202302": "202302 - 清潔劑及肥皂的製造",
  "industry_202901": "202901 - 樟腦產品的製造",
  "industry_202902": "202902 - 香(祭祀用)的製造",
  "industry_202903": "202903 - 蚊香的製造",
  "industry_202904": "202904 - 膠水的製造",
  "industry_202905": "202905 - 炸藥的製造",
  "industry_202999": "202999 - 其他雜項化學產品的製造",
  "industry_203000": "203000 - 人造纖維的製造",
  "industry_211100": "211100 - 中草藥及中成藥的製造",
  "industry_211200": "211200 - 西藥、診治用藥檢劑及醫護材料的製造",
  "industry_212000": "212000 - 獸醫用藥品的製造",
  "industry_221100": "221100 - 橡膠輪胎及內胎的製造、修補及翻新",
  "industry_221900": "221900 - 其他橡膠製品的製造",
  "industry_222100": "222100 - 塑膠花及枝葉的製造(金屬花卉及其他質料人造花卉除外)",
  "industry_222200": "222200 - 塑膠家庭用具的製造",
  "industry_222300": "222300 - 塑膠袋的製造(手袋除外)",
  "industry_222400": "222400 - 塑膠外殼及零件的製造",
  "industry_222901": "222901 - 塑膠製品印花",
  "industry_222902": "222902 - 乳膠製品及海綿製品的製造",
  "industry_222999": "222999 - 其他雜項塑膠製品的製造(傢具、玩具、體育用品及文具除外)",
  "industry_231000": "231000 - 玻璃、玻璃纖維及玻璃產品的製造",
  "industry_239100": "239100 - 耐火材料及建築用黏土製品的製造",
  "industry_239200": "239200 - 陶器、瓷器及瓦器製品的製造",
  "industry_239300": "239300 - 水泥、石灰及石膏的製造",
  "industry_239400": "239400 - 混凝土、水泥及石膏製品的製造",
  "industry_239500": "239500 - 雲石及石材的切割、成形和修飾",
  "industry_239900": "239900 - 其他非金屬礦產製品的製造",
  "industry_241000": "241000 - 基本鋼鐵的製造(鑄造除外)",
  "industry_242100": "242100 - 基本銅的製造",
  "industry_242200": "242200 - 基本鋁的製造",
  "industry_242300": "242300 - 貴金屬提煉(打金及打銀除外)",
  "industry_242900": "242900 - 其他基本有色金屬的製造(鑄造除外)",
  "industry_243100": "243100 - 鋼鐵的鑄造",
  "industry_243201": "243201 - 鑄銅",
  "industry_243202": "243202 - 鑄鋁",
  "industry_243299": "243299 - 其他有色金屬的鑄造",
  "industry_251101": "251101 - 金屬窗、門及閘的製造",
  "industry_251199": "251199 - 其他建築用金屬製品的製造",
  "industry_251200": "251200 - 油罐、水箱及金屬容器的製造",
  "industry_251300": "251300 - 蒸汽鍋爐的製造(中央供熱熱水鍋爐除外)",
  "industry_259100": "259100 - 金屬的鍛造、壓製、壓印和軋製；粉末冶金",
  "industry_259201": "259201 - 磨光、打磨及電鍍",
  "industry_259299": "259299 - 金屬的其他處理和包覆",
  "industry_259301": "259301 - 釘、螺絲及金屬鉸的製造",
  "industry_259302": "259302 - 刀具的製造",
  "industry_259303": "259303 - 手工具及金屬配件的製造",
  "industry_259901": "259901 - 金屬罐及金屬家庭用具的製造",
  "industry_259999": "259999 - 其他雜項金屬加工製品的製造",
  "industry_261100": "261100 - 電腦及電訊設備用電子零件及組件的製造",
  "industry_261900": "261900 - 其他電子零件及組件的製造",
  "industry_262000": "262000 - 電腦及其周邊設備的製造",
  "industry_263000": "263000 - 通訊設備的製造",
  "industry_264000": "264000 - 影音器材的製造",
  "industry_265100": "265100 - 量度、檢驗、導航及控制用設備的製造",
  "industry_265201": "265201 - 機械鐘及鐘肉、機械錶及錶肉的製造",
  "industry_265202": "265202 - 電子鐘及鐘肉、電子錶及錶肉的製造",
  "industry_265203": "265203 - 鐘錶殼及其他鐘錶零件的製造",
  "industry_266000": "266000 - 輻射、電子醫學及電子診療設備的製造",
  "industry_267100": "267100 - 攝影器材(光學與數碼)的製造",
  "industry_267200": "267200 - 其他光學儀器及設備(眼科用品除外)的製造",
  "industry_268000": "268000 - 磁性及光學媒體的製造",
  "industry_271000": "271000 - 電動摩打、發電機、變壓器、電力輸送及控制裝置的製造",
  "industry_272000": "272000 - 乾電池及蓄電池的製造",
  "industry_273100": "273100 - 電力電線、光纖電纜及其他電纜的製造",
  "industry_273200": "273200 - 配線器材的製造",
  "industry_274000": "274000 - 電力及非電力照明設備的製造",
  "industry_275000": "275000 - 家用電器的製造",
  "industry_279000": "279000 - 其他電力設備的製造",
  "industry_281100": "281100 - 引擎及渦輪機的製造(飛行器、 汽車及電單車引擎除外)",
  "industry_281200": "281200 - 流體動力設備的製造",
  "industry_281300": "281300 - 其他泵、壓縮機、水龍頭及活閥的製造",
  "industry_281400": "281400 - 軸承、齒輪、傳動裝置及驅動要件的製造",
  "industry_281500": "281500 - 烘爐及熔爐的製造",
  "industry_281600": "281600 - 起重及裝卸設備的製造",
  "industry_281700": "281700 - 辦公室機械設備的製造(電腦及其周邊設備除外)",
  "industry_281800": "281800 - 動力操作手工具的製造",
  "industry_281900": "281900 - 其他通用機械的製造",
  "industry_282100": "282100 - 農業及林業機械的製造",
  "industry_282200": "282200 - 金屬成型機械及機床的製造",
  "industry_282300": "282300 - 冶金機械的製造",
  "industry_282400": "282400 - 採礦業、採石業及建造業機械的製造",
  "industry_282500": "282500 - 食品、飲料及煙草加工用機械的製造",
  "industry_282600": "282600 - 紡織、成衣及皮革生產用機械的製造",
  "industry_282900": "282900 - 其他專用機械的製造",
  "industry_290000": "290000 - 汽車的裝嵌",
  "industry_301100": "301100 - 船舶及浮動結構體的製造",
  "industry_301200": "301200 - 娛樂及運動用小艇的製造",
  "industry_302000": "302000 - 鐵道車輛及機車的製造",
  "industry_303000": "303000 - 飛行器裝嵌及相關機械的製造",
  "industry_309100": "309100 - 電單車的製造",
  "industry_309200": "309200 - 自行車及傷病人士座車的製造",
  "industry_309900": "309900 - 其他運輸設備的製造",
  "industry_310101": "310101 - 木製傢具及固定裝置的製造",
  "industry_310102": "310102 - 藤製傢具的製造",
  "industry_310200": "310200 - 金屬傢具及固定裝置的製造",
  "industry_310900": "310900 - 其他材料製傢具及固定裝置的製造",
  "industry_321101": "321101 - 寶石切割及鑲嵌",
  "industry_321102": "321102 - 打金及打銀",
  "industry_321103": "321103 - 珠寶首飾(人造珠及仿製首飾除外)及貴金屬裝飾物的製造",
  "industry_321200": "321200 - 人造珠寶及相關物品的製造",
  "industry_322000": "322000 - 樂器的製造",
  "industry_323000": "323000 - 體育用品的製造",
  "industry_324100": "324100 - 木製玩具的製造",
  "industry_324200": "324200 - 橡膠玩具的製造",
  "industry_324300": "324300 - 塑膠玩具的製造",
  "industry_324400": "324400 - 金屬玩具的製造",
  "industry_324500": "324500 - 電子遊戲用品及玩具的製造",
  "industry_324900": "324900 - 其他遊戲用品及玩具的製造",
  "industry_325100": "325100 - 眼鏡及眼科用品的製造",
  "industry_325200": "325200 - 假牙的製造(包括牙科技術室)",
  "industry_325900": "325900 - 其他醫療與牙科儀器及用品的製造",
  "industry_329100": "329100 - 蠟燭的製造",
  "industry_329200": "329200 - 假髮及相關製品的製造",
  "industry_329301": "329301 - 鈕扣的製造",
  "industry_329302": "329302 - 拉鍊的製造",
  "industry_329400": "329400 - 雨傘及相關製品的製造",
  "industry_329500": "329500 - 文具的製造(紙製文具除外)",
  "industry_329600": "329600 - 商業廣告牌的製造(電力、霓虹及照明燈號除外)",
  "industry_329900": "329900 - 其他雜項產品的製造",
  "industry_331100": "331100 - 金屬製品維修",
  "industry_331200": "331200 - 機械維修",
  "industry_331300": "331300 - 電子及光學設備維修",
  "industry_331400": "331400 - 電力設備維修",
  "industry_331500": "331500 - 空中、海上及鐵道運輸設備維修",
  "industry_331900": "331900 - 其他非家居用設備維修",
  "industry_332000": "332000 - 工業機械及設備安裝",
  "industry_351000": "351000 - 發電、輸電及配電",
  "industry_352000": "352000 - 燃氣的製造及配送",
  "industry_359000": "359000 - 空調、蒸汽及類似產品透過輸配系統的供應",
  "industry_360000": "360000 - 自來水集取、處理及供應",
  "industry_370000": "370000 - 污水處理",
  "industry_381100": "381100 - 無害廢棄物的收集",
  "industry_381200": "381200 - 有害廢棄物的收集",
  "industry_382100": "382100 - 無害廢棄物的處理及處置",
  "industry_382200": "382200 - 有害廢棄物的處理及處置",
  "industry_383100": "383100 - 拆車",
  "industry_383900": "383900 - 其他資源的回收",
  "industry_390000": "390000 - 污染防治活動及其他廢棄物處理服務",
  "industry_411000": "411000 - 建築物上蓋建造",
  "industry_412000": "412000 - 結構鋼架工程",
  "industry_419100": "419100 - 建築物結構更改及加建工程",
  "industry_419200": "419200 - 小型建築物興建",
  "industry_419300": "419300 - 臨時建築物興建",
  "industry_419900": "419900 - 綜合及其他雜項樓房新建造工程",
  "industry_421000": "421000 - 土木工程項目的修建",
  "industry_422000": "422000 - 雜項土木工程",
  "industry_431100": "431100 - 建築物清拆",
  "industry_431201": "431201 - 地盤開拓及整理",
  "industry_431202": "431202 - 地基工程",
  "industry_431203": "431203 - 地盤勘探",
  "industry_431204": "431204 - 挖泥工程",
  "industry_431299": "431299 - 地盤的綜合及其他預備工程",
  "industry_432101": "432101 - 電線鋪設及電器裝設",
  "industry_432102": "432102 - 電器裝設兼水管鋪設",
  "industry_432103": "432103 - 火警及滅火設備安裝及保養",
  "industry_432104": "432104 - 防盜系統安裝及保養",
  "industry_432105": "432105 - 閉路通訊系統安裝及保養",
  "industry_432106": "432106 - 電訊設備安裝及保養",
  "industry_432199": "432199 - 綜合及其他電器及機械設備安裝及保養",
  "industry_432201": "432201 - 空氣調節及通風系統安裝及保養",
  "industry_432202": "432202 - 供水管及排水管鋪設",
  "industry_432203": "432203 - 鑽水井",
  "industry_432204": "432204 - 燃氣供應系統裝設、安裝及保養",
  "industry_432299": "432299 - 綜合及其他通風、燃氣及水務設備安裝及保養",
  "industry_432901": "432901 - 升降機及電動扶梯安裝及保養",
  "industry_432999": "432999 - 其他雜項建築設施安裝及保養",
  "industry_439101": "439101 - 樓房內部裝設、裝飾及修葺",
  "industry_439102": "439102 - 樓房外部翻新及修葺",
  "industry_439199": "439199 - 樓房內部及外部裝設、裝飾、翻新及修葺的綜合工程",
  "industry_439901": "439901 - 混凝土工程",
  "industry_439902": "439902 - 扎鐵工程(包括焊接)",
  "industry_439903": "439903 - 蓋搭竹棚架",
  "industry_439904": "439904 - 蓋搭金屬棚架",
  "industry_439905": "439905 - 木工",
  "industry_439906": "439906 - 石工",
  "industry_439907": "439907 - 金屬片鋪設",
  "industry_439908": "439908 - 天面及防水工程",
  "industry_439911": "439911 - 磚瓦鋪砌及批盪",
  "industry_439912": "439912 - 地板鋪砌(地面瓷磚鋪砌除外)",
  "industry_439913": "439913 - 裝窗及玻璃裝配",
  "industry_439914": "439914 - 油漆",
  "industry_439915": "439915 - 吊機操作",
  "industry_439916": "439916 - 鋪地毯、安裝窗簾及裱牆紙",
  "industry_439917": "439917 - 欄柵、路軌及有關金屬結構安裝",
  "industry_439918": "439918 - 裝飾品裝設",
  "industry_439999": "439999 - 其他雜項竣工前的修整及專門建造工程",
  "industry_451100": "451100 - 按收費或以合約形式的出口貿易",
  "industry_451201": "451201 - 禽畜出口貿易",
  "industry_451202": "451202 - 棉花、紡織纖維及紗線出口貿易",
  "industry_451203": "451203 - 皮革出口貿易(包括人造皮及其他塑膠皮)",
  "industry_451204": "451204 - 橡膠出口貿易",
  "industry_451205": "451205 - 木材及藤料出口貿易",
  "industry_451206": "451206 - 鮮花及植物出口貿易",
  "industry_451207": "451207 - 寵物動物(包括觀賞魚類)出口貿易",
  "industry_451299": "451299 - 其他農產品及活動物出口貿易",
  "industry_451301": "451301 - 罐頭食品出口貿易",
  "industry_451302": "451302 - 糖果及餅乾出口貿易",
  "industry_451303": "451303 - 乳類製品出口貿易",
  "industry_451304": "451304 - 食油出口貿易",
  "industry_451305": "451305 - 食用硬殼果、果仁及乾豆出口貿易",
  "industry_451306": "451306 - 蛋類出口貿易",
  "industry_451307": "451307 - 動物及寵物飼料出口貿易",
  "industry_451308": "451308 - 經乾製或醃製的魚類及其他海產食品出口貿易",
  "industry_451311": "451311 - 新鮮或急凍的魚類及其他海產食品出口貿易",
  "industry_451312": "451312 - 新鮮蔬果出口貿易",
  "industry_451313": "451313 - 新鮮或急凍肉類出口貿易(包括家禽肉類及野味)",
  "industry_451314": "451314 - 粉麵出口貿易",
  "industry_451315": "451315 - 食米出口貿易",
  "industry_451316": "451316 - 糖及麵粉出口貿易",
  "industry_451317": "451317 - 茶葉、咖啡及可可出口貿易",
  "industry_451318": "451318 - 經烤製、乾製或醃製的肉類出口貿易",
  "industry_451321": "451321 - 經醃製的食品及香料出口貿易",
  "industry_451322": "451322 - 煙草、香煙及雪茄煙出口貿易",
  "industry_451323": "451323 - 酒類飲品出口貿易",
  "industry_451324": "451324 - 一般糧油食品出口貿易",
  "industry_451399": "451399 - 其他專門食品出口貿易",
  "industry_451401": "451401 - 鞋及鞋類配件出口貿易",
  "industry_451402": "451402 - 布料出口貿易",
  "industry_451403": "451403 - 縫紉用輔件及飾料出口貿易",
  "industry_451404": "451404 - 服裝出口貿易",
  "industry_451405": "451405 - 刺繡及抽紗製品出口貿易",
  "industry_451406": "451406 - 日用寢具織品、帳幔、地氈、圍氈及同類製品出口貿易",
  "industry_451407": "451407 - 繩索及網類用具出口貿易",
  "industry_451408": "451408 - 雨傘出口貿易",
  "industry_451411": "451411 - 皮革或類似材料製的行李箱、手袋及同類物品出口貿易",
  "industry_451421": "451421 - 古玩及工藝品出口貿易",
  "industry_451422": "451422 - 竹製品及藤製品出口貿易(傢具及固定裝置除外)",
  "industry_451423": "451423 - 書報及期刊出口貿易",
  "industry_451424": "451424 - 陶瓷及玻璃製品出口貿易",
  "industry_451425": "451425 - 中成藥及中草藥出口貿易",
  "industry_451426": "451426 - 非電動的煮食及廚房用具出口貿易",
  "industry_451427": "451427 - 衛浴用劑及清潔劑料出口貿易",
  "industry_451428": "451428 - 藥物出口貿易(中成藥及中草藥除外)",
  "industry_451431": "451431 - 化妝品及香水出口貿易",
  "industry_451432": "451432 - 珠寶首飾及貴金屬裝飾物出口貿易",
  "industry_451433": "451433 - 人造珠寶及相關物品出口貿易",
  "industry_451434": "451434 - 五金器具及金屬配件出口貿易",
  "industry_451435": "451435 - 眼鏡及光學用品出口貿易",
  "industry_451436": "451436 - 攝影器材及用品出口貿易",
  "industry_451437": "451437 - 已錄製資料的錄音帶、錄影帶、光碟、數碼視訊光碟及類似媒體出口貿易",
  "industry_451438": "451438 - 袋類製品出口貿易(手袋及旅行袋除外)",
  "industry_451441": "451441 - 文具出口貿易",
  "industry_451442": "451442 - 樂器出口貿易",
  "industry_451443": "451443 - 體育用品出口貿易",
  "industry_451444": "451444 - 玩具出口貿易",
  "industry_451445": "451445 - 電腦遊戲出口貿易",
  "industry_451446": "451446 - 鐘錶出口貿易",
  "industry_451447": "451447 - 紙製品出口貿易",
  "industry_451448": "451448 - 中式宗教物品出口貿易",
  "industry_451451": "451451 - 塑膠製品出口貿易(包括塑膠飾物及塑膠花)",
  "industry_451452": "451452 - 電器出口貿易(機械、辦公室及電訊設備及器材除外)",
  "industry_451499": "451499 - 其他家庭用品出口貿易",
  "industry_451501": "451501 - 汽車出口貿易",
  "industry_451502": "451502 - 電單車出口貿易",
  "industry_451503": "451503 - 汽車及電單車配件及零件出口貿易",
  "industry_451599": "451599 - 其他運輸設備出口貿易(汽車及電單車除外)",
  "industry_451601": "451601 - 電腦及電腦周邊設備出口貿易",
  "industry_451602": "451602 - 電腦套裝軟件出口貿易",
  "industry_451611": "451611 - 電訊設備出口貿易",
  "industry_451612": "451612 - 空白錄音帶、錄影帶、磁碟、光碟及數碼視訊光碟出口貿易",
  "industry_451613": "451613 - 電子零件出口貿易",
  "industry_451621": "451621 - 農業機械、設備及其配備出口貿易",
  "industry_451631": "451631 - 科學及專業儀器出口貿易(醫療及牙科儀器除外)",
  "industry_451632": "451632 - 衣車及其零件出口貿易(包括衣車架)",
  "industry_451633": "451633 - 醫療、衛生及醫院設備與用品出口貿易",
  "industry_451634": "451634 - 辦公室器材及設備出口貿易(電腦、傢具及固定裝置除外)",
  "industry_451635": "451635 - 鐘錶殼及其他鐘錶零件出口貿易",
  "industry_451699": "451699 - 其他機械及設備出口貿易(傢具除外)",
  "industry_451701": "451701 - 柴炭煤類燃料出口貿易",
  "industry_451702": "451702 - 燃油及潤滑油出口貿易",
  "industry_451703": "451703 - 石油產品(火水及石油氣)出口貿易",
  "industry_451711": "451711 - 金屬及金屬礦出口貿易",
  "industry_451721": "451721 - 建材、五金、水管設備及其配備出口貿易",
  "industry_451731": "451731 - 傢具及固定裝置出口貿易",
  "industry_451741": "451741 - 化學原料及有關產品出口貿易",
  "industry_451742": "451742 - 油漆及清漆出口貿易",
  "industry_451743": "451743 - 工業及印刷用紙出口貿易",
  "industry_451744": "451744 - 廢物及廢料出口貿易",
  "industry_451799": "451799 - 其他專賣產品出口貿易",
  "industry_451900": "451900 - 非專賣貨品出口貿易",
  "industry_452100": "452100 - 按收費或以合約形式進口批發",
  "industry_452201": "452201 - 禽畜進口批發",
  "industry_452202": "452202 - 棉花、紡織纖維及紗線進口批發",
  "industry_452203": "452203 - 皮革進口批發(包括人造皮及其他塑膠皮)",
  "industry_452204": "452204 - 橡膠進口批發",
  "industry_452205": "452205 - 木材及藤料進口批發",
  "industry_452206": "452206 - 鮮花及植物進口批發",
  "industry_452207": "452207 - 寵物動物(包括觀賞魚類)進口批發",
  "industry_452299": "452299 - 其他農產品及活動物進口批發",
  "industry_452301": "452301 - 罐頭食品進口批發",
  "industry_452302": "452302 - 糖果及餅乾進口批發",
  "industry_452303": "452303 - 乳類製品進口批發",
  "industry_452304": "452304 - 食油進口批發",
  "industry_452305": "452305 - 食用硬殼果、果仁及乾豆進口批發",
  "industry_452306": "452306 - 蛋類進口批發",
  "industry_452307": "452307 - 動物及寵物飼料進口批發",
  "industry_452308": "452308 - 經乾製或醃製的魚類及其他海產食品進口批發",
  "industry_452311": "452311 - 新鮮或急凍的魚類及其他海產食品進口批發",
  "industry_452312": "452312 - 新鮮蔬果進口批發",
  "industry_452313": "452313 - 新鮮或急凍肉類進口批發(包括家禽肉類及野味)",
  "industry_452314": "452314 - 粉麵進口批發",
  "industry_452315": "452315 - 食米進口批發",
  "industry_452316": "452316 - 糖及麵粉進口批發",
  "industry_452317": "452317 - 茶葉、咖啡及可可進口批發",
  "industry_452318": "452318 - 經烤製、乾製或醃製的肉類進口批發",
  "industry_452321": "452321 - 經醃製的食品及香料進口批發",
  "industry_452322": "452322 - 煙草、香煙及雪茄煙進口批發",
  "industry_452323": "452323 - 酒類飲品進口批發",
  "industry_452324": "452324 - 一般糧油食品進口批發",
  "industry_452399": "452399 - 其他專門食品進口批發",
  "industry_452401": "452401 - 鞋及鞋類配件進口批發",
  "industry_452402": "452402 - 布料進口批發",
  "industry_452403": "452403 - 縫紉用輔件及飾料進口批發",
  "industry_452404": "452404 - 服裝進口批發",
  "industry_452405": "452405 - 刺繡及抽紗製品進口批發",
  "industry_452406": "452406 - 日用寢具織品、帳幔、地氈、圍氈及同類製品進口批發",
  "industry_452407": "452407 - 繩索及網類用具進口批發",
  "industry_452408": "452408 - 雨傘進口批發",
  "industry_452411": "452411 - 皮革或類似材料製的行李箱、手袋及同類物品進口批發",
  "industry_452421": "452421 - 古玩及工藝品進口批發",
  "industry_452422": "452422 - 竹製品及藤製品進口批發(傢具及固定裝置除外)",
  "industry_452423": "452423 - 書報及期刊進口批發",
  "industry_452424": "452424 - 陶瓷及玻璃製品進口批發",
  "industry_452425": "452425 - 中成藥及中草藥進口批發",
  "industry_452426": "452426 - 非電動的煮食及廚房用具進口批發",
  "industry_452427": "452427 - 衛浴用劑及清潔劑料進口批發",
  "industry_452428": "452428 - 藥物進口批發(中成藥及中草藥除外)",
  "industry_452431": "452431 - 化妝品及香水進口批發",
  "industry_452432": "452432 - 珠寶首飾及貴金屬裝飾物進口批發",
  "industry_452433": "452433 - 人造珠寶及相關物品進口批發",
  "industry_452434": "452434 - 五金器具及金屬配件進口批發",
  "industry_452435": "452435 - 眼鏡及光學用品進口批發",
  "industry_452436": "452436 - 攝影器材及用品進口批發",
  "industry_452437": "452437 - 已錄製資料的錄音帶、錄影帶、光碟、數碼視訊光碟及類似媒體進口批發",
  "industry_452438": "452438 - 袋類製品進口批發(手袋及旅行袋除外)",
  "industry_452441": "452441 - 文具進口批發",
  "industry_452442": "452442 - 樂器進口批發",
  "industry_452443": "452443 - 體育用品進口批發",
  "industry_452444": "452444 - 玩具進口批發",
  "industry_452445": "452445 - 電腦遊戲進口批發",
  "industry_452446": "452446 - 鐘錶進口批發",
  "industry_452447": "452447 - 紙製品進口批發",
  "industry_452448": "452448 - 中式宗教物品進口批發",
  "industry_452451": "452451 - 塑膠製品進口批發(包括塑膠飾物及塑膠花)",
  "industry_452452": "452452 - 電器進口批發(機械、辦公室及電訊設備及器材除外)",
  "industry_452499": "452499 - 其他家庭用品進口批發",
  "industry_452501": "452501 - 汽車進口批發",
  "industry_452502": "452502 - 電單車進口批發",
  "industry_452503": "452503 - 汽車及電單車配件及零件進口批發",
  "industry_452599": "452599 - 其他運輸設備進口批發(汽車及電單車除外)",
  "industry_452601": "452601 - 電腦及電腦周邊設備進口批發",
  "industry_452602": "452602 - 電腦套裝軟件進口批發",
  "industry_452611": "452611 - 電訊設備及其零件進口批發",
  "industry_452612": "452612 - 空白錄音帶、錄影帶、磁碟、光碟及數碼視訊光碟進口批發",
  "industry_452613": "452613 - 電子零件進口批發",
  "industry_452621": "452621 - 農業機械、設備及其配備進口批發",
  "industry_452631": "452631 - 科學及專業儀器進口批發(醫療及牙科儀器除外)",
  "industry_452632": "452632 - 衣車及其零件進口批發(包括衣車架)",
  "industry_452633": "452633 - 醫療、衛生及醫院設備與用品進口批發",
  "industry_452634": "452634 - 辦公室器材及設備進口批發(電腦、傢具及固定裝置除外)",
  "industry_452635": "452635 - 鐘錶殼及其他鐘錶零件進口批發",
  "industry_452699": "452699 - 其他機械及設備進口批發(傢具除外)",
  "industry_452701": "452701 - 柴炭煤類燃料進口批發",
  "industry_452702": "452702 - 燃油及潤滑油進口批發",
  "industry_452703": "452703 - 石油產品(火水及石油氣)進口批發",
  "industry_452711": "452711 - 金屬及金屬礦進口批發",
  "industry_452721": "452721 - 建材、五金、水管設備及其配備進口批發",
  "industry_452731": "452731 - 傢具及固定裝置進口批發",
  "industry_452741": "452741 - 化學原料及有關產品進口批發",
  "industry_452742": "452742 - 油漆及清漆進口批發",
  "industry_452743": "452743 - 工業及印刷用紙進口批發",
  "industry_452744": "452744 - 廢物及廢料進口批發",
  "industry_452799": "452799 - 其他專賣產品進口批發",
  "industry_452900": "452900 - 非專賣貨品進口批發",
  "industry_460100": "460100 - 批發經紀及代理(包括拍賣人)",
  "industry_460201": "460201 - 禽畜批發",
  "industry_460202": "460202 - 棉花、紡織纖維及紗線批發",
  "industry_460203": "460203 - 皮革批發(包括人造皮及其他塑膠皮)",
  "industry_460204": "460204 - 橡膠批發",
  "industry_460205": "460205 - 木材及藤料批發",
  "industry_460206": "460206 - 鮮花及植物批發",
  "industry_460207": "460207 - 寵物動物(包括觀賞魚類)批發",
  "industry_460299": "460299 - 其他農業原材料及活動物批發",
  "industry_460301": "460301 - 罐頭食品批發",
  "industry_460302": "460302 - 糖果及餅乾批發",
  "industry_460303": "460303 - 乳類製品批發",
  "industry_460304": "460304 - 食油批發",
  "industry_460305": "460305 - 食用硬殼果、果仁及乾豆批發",
  "industry_460306": "460306 - 蛋類批發",
  "industry_460307": "460307 - 動物及寵物飼料批發",
  "industry_460308": "460308 - 經乾製或醃製的魚類及其他海產食品批發",
  "industry_460311": "460311 - 新鮮或急凍的魚類及其他海產食品批發",
  "industry_460312": "460312 - 新鮮蔬果批發",
  "industry_460313": "460313 - 新鮮或急凍肉類批發(包括家禽肉類及野味)",
  "industry_460314": "460314 - 粉麵批發",
  "industry_460315": "460315 - 食米批發",
  "industry_460316": "460316 - 糖及麵粉批發",
  "industry_460317": "460317 - 茶葉、咖啡及可可批發",
  "industry_460318": "460318 - 經烤製、乾製或醃製的肉類批發",
  "industry_460321": "460321 - 經醃製的食品及香料批發",
  "industry_460322": "460322 - 煙草、香煙及雪茄煙批發",
  "industry_460323": "460323 - 酒類飲品批發",
  "industry_460324": "460324 - 一般糧油食品批發",
  "industry_460399": "460399 - 其他專門食品批發",
  "industry_460401": "460401 - 鞋及鞋類配件批發",
  "industry_460402": "460402 - 布料批發",
  "industry_460403": "460403 - 縫紉用輔件及飾料批發",
  "industry_460404": "460404 - 服裝批發",
  "industry_460405": "460405 - 刺繡及抽紗製品批發",
  "industry_460406": "460406 - 日用寢具織品、帳幔、地氈、圍氈及同類製品批發",
  "industry_460407": "460407 - 繩索及網類用具批發",
  "industry_460408": "460408 - 雨傘批發",
  "industry_460411": "460411 - 皮革或類似材料製的行李箱、手袋及同類物品批發",
  "industry_460421": "460421 - 古玩及工藝品批發",
  "industry_460422": "460422 - 竹製品及藤製品批發(傢具及固定裝置除外)",
  "industry_460423": "460423 - 書報及期刊批發",
  "industry_460424": "460424 - 陶瓷及玻璃製品批發",
  "industry_460425": "460425 - 中成藥及中草藥批發",
  "industry_460426": "460426 - 非電動的煮食及廚房用具批發",
  "industry_460427": "460427 - 衛浴用劑及清潔劑料批發",
  "industry_460428": "460428 - 藥物批發(中成藥及中草藥除外)",
  "industry_460431": "460431 - 化妝品及香水批發",
  "industry_460432": "460432 - 珠寶首飾及貴金屬裝飾物批發",
  "industry_460433": "460433 - 人造珠寶及相關物品批發",
  "industry_460434": "460434 - 五金器具及金屬配件批發",
  "industry_460435": "460435 - 眼鏡及光學用品批發",
  "industry_460436": "460436 - 攝影器材及用品批發",
  "industry_460437": "460437 - 已錄製資料的錄音帶、錄影帶、光碟、數碼視訊光碟及類似媒體批發",
  "industry_460438": "460438 - 袋類製品批發(手袋及旅行袋除外)",
  "industry_460441": "460441 - 文具批發",
  "industry_460442": "460442 - 樂器批發",
  "industry_460443": "460443 - 體育用品批發",
  "industry_460444": "460444 - 玩具批發",
  "industry_460445": "460445 - 電腦遊戲批發",
  "industry_460446": "460446 - 鐘錶批發",
  "industry_460447": "460447 - 紙製品批發",
  "industry_460448": "460448 - 中式宗教物品批發",
  "industry_460451": "460451 - 塑膠製品批發(包括塑膠飾物及塑膠花)",
  "industry_460452": "460452 - 電器批發(機械、辦公室及電訊設備及器材除外)",
  "industry_460499": "460499 - 其他家庭用品批發",
  "industry_460501": "460501 - 汽車批發",
  "industry_460502": "460502 - 電單車批發",
  "industry_460503": "460503 - 汽車及電單車配件及零件批發",
  "industry_460599": "460599 - 其他運輸設備批發(汽車及電單車除外)",
  "industry_460601": "460601 - 電腦及電腦周邊設備批發",
  "industry_460602": "460602 - 電腦套裝軟件批發",
  "industry_460611": "460611 - 電訊設備及其零件批發",
  "industry_460612": "460612 - 空白錄音帶、錄影帶、磁碟、光碟及數碼視訊光碟批發",
  "industry_460613": "460613 - 電子零件批發",
  "industry_460621": "460621 - 農業機械、設備及其配備批發",
  "industry_460631": "460631 - 科學及專業儀器批發(醫療及牙科儀器除外)",
  "industry_460632": "460632 - 衣車及其零件批發(包括衣車架)",
  "industry_460633": "460633 - 醫療、衛生及醫院設備與用品批發",
  "industry_460634": "460634 - 辦公室器材及設備批發(電腦、傢具及固定裝置除外)",
  "industry_460635": "460635 - 鐘錶殼及其他鐘錶零件批發",
  "industry_460699": "460699 - 其他機械及設備批發(傢具除外)",
  "industry_460701": "460701 - 柴炭煤類燃料批發",
  "industry_460702": "460702 - 燃油及潤滑油批發",
  "industry_460703": "460703 - 石油產品(火水及石油氣)批發",
  "industry_460711": "460711 - 金屬及金屬礦批發",
  "industry_460721": "460721 - 建材、五金、水管設備及其配備批發",
  "industry_460731": "460731 - 傢具及固定裝置批發",
  "industry_460741": "460741 - 化學原料及有關產品批發",
  "industry_460742": "460742 - 油漆及清漆批發",
  "industry_460743": "460743 - 工業及印刷用紙批發",
  "industry_460744": "460744 - 廢物及廢料批發",
  "industry_460799": "460799 - 其他專賣產品批發",
  "industry_460900": "460900 - 非專賣貨品批發",
  "industry_471101": "471101 - 超級市場",
  "industry_471102": "471102 - 便利店",
  "industry_471103": "471103 - 一般糧油食品零售店",
  "industry_471104": "471104 - 士多及辦館",
  "industry_471901": "471901 - 百貨公司",
  "industry_471999": "471999 - 其他綜合商品零售店",
  "industry_472101": "472101 - 麵包及糕餅類食品零售店",
  "industry_472102": "472102 - 糖果及餅乾零售店",
  "industry_472103": "472103 - 經乾製或醃製的魚類及其他海產食品零售店",
  "industry_472104": "472104 - 新鮮或急凍的魚類、其他海產食品及肉類零售店",
  "industry_472105": "472105 - 新鮮蔬果零售店",
  "industry_472106": "472106 - 粉麵零售店",
  "industry_472107": "472107 - 經醃製的食品及香料零售店(包括經乾製或醃製的蔬果)",
  "industry_472108": "472108 - 食米零售店",
  "industry_472111": "472111 - 經烤製、乾製或醃製的肉類零售店",
  "industry_472112": "472112 - 茶葉零售店",
  "industry_472113": "472113 - 豆腐及豆類製品零售店",
  "industry_472114": "472114 - 蛋類零售店",
  "industry_472199": "472199 - 其他專門食品零售店(不設座位)",
  "industry_472201": "472201 - 酒類飲品專賣零售店",
  "industry_472202": "472202 - 非酒類飲品專賣零售店",
  "industry_472299": "472299 - 飲品(包括酒類及非酒類)零售店",
  "industry_472300": "472300 - 煙草製品專賣零售店",
  "industry_473100": "473100 - 油站",
  "industry_473200": "473200 - 柴炭煤類燃料零售店",
  "industry_473300": "473300 - 火水及石油氣零售店",
  "industry_474101": "474101 - 電訊設備零售店",
  "industry_474102": "474102 - 電腦及周邊設備零售店",
  "industry_474103": "474103 - 電腦套裝軟件零售店",
  "industry_474200": "474200 - 視聽器材零售店",
  "industry_475101": "475101 - 布料零售店",
  "industry_475102": "475102 - 縫紉用輔件及飾料零售店",
  "industry_475103": "475103 - 針織用紗線零售店",
  "industry_475104": "475104 - 刺繡及抽紗製品零售店",
  "industry_475105": "475105 - 日用寢具零售店",
  "industry_475106": "475106 - 帳幔零售店(包括捲軸式窗簾及一般窗簾)",
  "industry_475107": "475107 - 繩索及網類用具零售店",
  "industry_475199": "475199 - 其他紡織品或多類紡織品綜合零售店",
  "industry_475200": "475200 - 五金器具、金屬配件、油漆及其他裝修材料零售店",
  "industry_475300": "475300 - 地毯、圍氈、牆壁與地板覆蓋物零售店",
  "industry_475901": "475901 - 竹製品及藤製品零售店(傢具及固定裝置除外)",
  "industry_475902": "475902 - 陶瓷及玻璃製品零售店",
  "industry_475903": "475903 - 非電動的廚房及煮食用具零售店",
  "industry_475904": "475904 - 帆布及帆布製品零售店",
  "industry_475905": "475905 - 電器零售店(機械、辦公室及電訊設備及器材、視聽器材除外)",
  "industry_475906": "475906 - 傢具及固定裝置零售店",
  "industry_475999": "475999 - 其他家庭用品零售店",
  "industry_476100": "476100 - 書報及文具零售店",
  "industry_476200": "476200 - 錄音及錄像零售店",
  "industry_476300": "476300 - 運動設備零售店",
  "industry_476401": "476401 - 玩具零售店",
  "industry_476402": "476402 - 電腦遊戲零售店",
  "industry_476403": "476403 - 賭具零售店",
  "industry_477101": "477101 - 鞋及鞋類配件零售店",
  "industry_477102": "477102 - 服裝零售店",
  "industry_477103": "477103 - 雨傘零售店",
  "industry_477104": "477104 - 皮革或類似材料製的行李箱、手袋及同類物品零售店",
  "industry_477199": "477199 - 衣服、鞋類及皮革製品綜合零售店",
  "industry_477201": "477201 - 中草藥及中成藥零售店",
  "industry_477202": "477202 - 藥物及健康補給品零售店(兼售或不兼售化妝品及個人護理用品)",
  "industry_477203": "477203 - 醫療用品零售店",
  "industry_477204": "477204 - 化妝品及個人護理用品零售店",
  "industry_477301": "477301 - 汽車零售店",
  "industry_477302": "477302 - 電單車零售店",
  "industry_477303": "477303 - 汽車及電單車配件及零件零售店",
  "industry_477399": "477399 - 其他運輸設備零售店(汽車及電單車除外)",
  "industry_477401": "477401 - 工藝品零售店",
  "industry_477402": "477402 - 珠寶首飾及貴金屬裝飾物零售店",
  "industry_477403": "477403 - 人造珠寶及相關物品零售店",
  "industry_477404": "477404 - 眼鏡店",
  "industry_477405": "477405 - 攝影器材及用品零售店",
  "industry_477406": "477406 - 袋類製品零售店(手袋及旅行袋除外)",
  "industry_477407": "477407 - 樂器零售店",
  "industry_477408": "477408 - 鐘錶零售店",
  "industry_477411": "477411 - 紙製品零售店",
  "industry_477412": "477412 - 中式宗教物品零售店",
  "industry_477413": "477413 - 花卉及植物零售店(包括種子、化肥及園藝用品)",
  "industry_477414": "477414 - 寵物及動物零售店(包括飼料及配件)",
  "industry_477415": "477415 - 防火設備零售店",
  "industry_477416": "477416 - 禮品、精品及紀念品零售店",
  "industry_477417": "477417 - 奢侈品綜合店",
  "industry_477418": "477418 - 科學及專業儀器零售店(醫療及牙科設備與器材除外)",
  "industry_477421": "477421 - 衣車及其零件零售店(包括衣車架)",
  "industry_477422": "477422 - 辦公室器材零售店(電腦、傢具及固定裝置除外)",
  "industry_477499": "477499 - 其他雜項全新商品零售店",
  "industry_477501": "477501 - 古玩零售店",
  "industry_477502": "477502 - 集郵社",
  "industry_477599": "477599 - 其他二手貨品零售店",
  "industry_478101": "478101 - 經流動貨攤的食品、飲料及煙草製品零售",
  "industry_478102": "478102 - 經流動貨攤的紡織品、衣著及鞋類零售",
  "industry_478199": "478199 - 經流動貨攤的其他商品零售",
  "industry_478201": "478201 - 經郵購或互聯網的零售",
  "industry_478299": "478299 - 其他無店面和不經流動貨攤的零售",
  "industry_491000": "491000 - 鐵路及纜索運輸",
  "industry_492100": "492100 - 公共巴士服務",
  "industry_492201": "492201 - 市區的士服務",
  "industry_492202": "492202 - 新界的士服務",
  "industry_492203": "492203 - 大嶼山的士服務",
  "industry_492300": "492300 - 非專線公共小型巴士服務",
  "industry_492400": "492400 - 專線公共小型巴士服務",
  "industry_492500": "492500 - 校車服務",
  "industry_492601": "492601 - 配備司機的載客車輛出租服務(只提供本地運輸服務)",
  "industry_492602": "492602 - 配備司機的載客車輛出租服務(有跨境運輸服務)",
  "industry_492701": "492701 - 貨車(拖頭除外)運輸服務(只提供本地運輸服務)",
  "industry_492702": "492702 - 貨車(拖頭除外)運輸服務(有跨境運輸服務)",
  "industry_492801": "492801 - 拖頭拖運服務(只提供本地運輸服務)",
  "industry_492802": "492802 - 拖頭拖運服務(有跨境運輸服務)",
  "industry_499000": "499000 - 其他陸路運輸服務",
  "industry_501100": "501100 - 船務代理及管理人",
  "industry_501200": "501200 - 海外船公司駐港辦事處",
  "industry_501301": "501301 - 作客運服務的遠洋輪船船東",
  "industry_501302": "501302 - 作貨運服務的遠洋輪船船東",
  "industry_501401": "501401 - 遠洋客輪營運者",
  "industry_501402": "501402 - 遠洋貨輪營運者",
  "industry_501501": "501501 - 往來香港與珠江三角洲港口的客輪船東及營運者",
  "industry_501502": "501502 - 往來香港與珠江三角洲港口的貨輪船東及營運者",
  "industry_502101": "502101 - 持牌及專營渡輪服務",
  "industry_502199": "502199 - 街渡及非固定航線港內水上客運服務",
  "industry_502200": "502200 - 港內水上貨運服務",
  "industry_510100": "510100 - 以香港作基地的航空公司及直升機公司",
  "industry_510201": "510201 - 海外航空公司的駐港辦事處(客運)",
  "industry_510202": "510202 - 海外航空公司的駐港辦事處(貨運)",
  "industry_510900": "510900 - 其他航空運輸服務",
  "industry_521100": "521100 - 冷藏庫",
  "industry_521200": "521200 - 通用貨倉",
  "industry_522101": "522101 - 停車場服務",
  "industry_522102": "522102 - 汽車隧道、橋樑及高速公路營運者",
  "industry_522103": "522103 - 陸路運輸中的行李或貨物提存上落服務",
  "industry_522199": "522199 - 其他陸路運輸輔助服務活動",
  "industry_522201": "522201 - 貨櫃碼頭及貨運碼頭營運者",
  "industry_522202": "522202 - 中流作業",
  "industry_522203": "522203 - 港口設施營運者(貨櫃及貨運碼頭除外)",
  "industry_522204": "522204 - 貨櫃後勤活動",
  "industry_522299": "522299 - 其他水上運輸輔助服務活動",
  "industry_522300": "522300 - 航空運輸輔助服務活動",
  "industry_522901": "522901 - 航空貨運代理服務",
  "industry_522902": "522902 - 海上貨運代理服務",
  "industry_522903": "522903 - 陸路貨運代理服務",
  "industry_522904": "522904 - 包裝及裝箱服務",
  "industry_522905": "522905 - 驗貨、抽樣檢驗及稱量服務",
  "industry_522906": "522906 - 船隻經紀",
  "industry_522999": "522999 - 其他雜項運輸輔助活動",
  "industry_531000": "531000 - 郵政活動",
  "industry_532100": "532100 - 國際速遞活動",
  "industry_532200": "532200 - 本地速遞活動",
  "industry_550100": "550100 - 酒店",
  "industry_550900": "550900 - 賓館、旅舍及其他短期住宿活動",
  "industry_561101": "561101 - 港式茶餐廳",
  "industry_561103": "561103 - 日式餐館",
  "industry_561104": "561104 - 韓式餐館",
  "industry_561105": "561105 - 泰式餐館",
  "industry_561106": "561106 - 越式餐館",
  "industry_561107": "561107 - 法式餐館",
  "industry_561108": "561108 - 意式餐館",
  "industry_561109": "561109 - 粵式酒樓菜館",
  "industry_561110": "561110 - 京、川、滬式酒樓菜館",
  "industry_561111": "561111 - 其他中菜的中式酒樓菜館",
  "industry_561199": "561199 - 其他餐館",
  "industry_561200": "561200 - 快餐店",
  "industry_561901": "561901 - 其他自設座位的餐食場所",
  "industry_561902": "561902 - 美食廣場內的小店",
  "industry_561903": "561903 - 外賣店及不設座位的餐膳售賣處",
  "industry_562000": "562000 - 聚會餐飲及其他膳食服務活動",
  "industry_563100": "563100 - 酒吧及酒廊",
  "industry_563200": "563200 - 咖啡店",
  "industry_563300": "563300 - 涼茶鋪",
  "industry_563900": "563900 - 其他飲品供應場所",
  "industry_581100": "581100 - 書籍、工商名錄及郵寄名冊出版",
  "industry_581201": "581201 - 報紙出版",
  "industry_581202": "581202 - 雜誌及期刊出版",
  "industry_581900": "581900 - 其他出版活動",
  "industry_582100": "582100 - 電腦遊戲出版",
  "industry_582900": "582900 - 其他軟件出版",
  "industry_591100": "591100 - 電影、錄像及電視節目製作活動",
  "industry_591200": "591200 - 電影、錄像及電視節目後期製作活動",
  "industry_591300": "591300 - 電影、錄像及電視節目發行活動",
  "industry_591400": "591400 - 電影放映活動",
  "industry_592000": "592000 - 錄音及音樂出版活動",
  "industry_601000": "601000 - 電台廣播",
  "industry_602000": "602000 - 電視節目編製及廣播活動",
  "industry_611000": "611000 - 電訊網絡營運",
  "industry_619100": "619100 - 互聯網接駁服務",
  "industry_619900": "619900 - 其他雜項電訊活動",
  "industry_620101": "620101 - 電腦遊戲開發",
  "industry_620199": "620199 - 其他軟件開發及程式編寫活動",
  "industry_620200": "620200 - 資訊科技顧問活動及電腦設備管理活動",
  "industry_620900": "620900 - 其他資訊科技服務活動",
  "industry_631100": "631100 - 資料處理、寄存及相關活動",
  "industry_631200": "631200 - 入門網站",
  "industry_639100": "639100 - 新聞通訊社活動",
  "industry_639900": "639900 - 其他資訊服務活動",
  "industry_641100": "641100 - 貨幣管理機構",
  "industry_641201": "641201 - 持牌銀行",
  "industry_641202": "641202 - 有限制牌照銀行",
  "industry_641203": "641203 - 接受存款公司",
  "industry_641300": "641300 - 海外銀行本地代表辦事處",
  "industry_642000": "642000 - 投資及控股公司",
  "industry_644000": "644000 - 信託、基金及相關金融工具",
  "industry_649100": "649100 - 融資租賃",
  "industry_649201": "649201 - 當鋪",
  "industry_649299": "649299 - 私人貸款、按揭、分期付款信貸及其他信貸提供",
  "industry_649901": "649901 - 外幣兌換店及外匯經紀或交易商",
  "industry_649999": "649999 - 其他雜項金融服務活動",
  "industry_651100": "651100 - 人壽保險承保人",
  "industry_651200": "651200 - 非人壽保險承保人",
  "industry_652000": "652000 - 退休基金",
  "industry_661100": "661100 - 證券及期貨市場管理",
  "industry_661201": "661201 - 投資銀行活動",
  "industry_661202": "661202 - 證券經紀服務",
  "industry_661203": "661203 - 商品期貨及金銀貿易經紀及交易商",
  "industry_661901": "661901 - 投資顧問服務",
  "industry_661902": "661902 - 受託人及保管人",
  "industry_661999": "661999 - 其他雜項金融服務輔助活動",
  "industry_662100": "662100 - 風險及損失評估",
  "industry_662200": "662200 - 保險代理及經紀活動",
  "industry_662900": "662900 - 其他保險及退休基金輔助活動",
  "industry_663000": "663000 - 基金管理",
  "industry_681100": "681100 - 地產發展",
  "industry_681200": "681200 - 地產租賃",
  "industry_681300": "681300 - 地產發展兼租賃",
  "industry_681400": "681400 - 物業擁有及轉售",
  "industry_682100": "682100 - 地產經紀及代理",
  "industry_682200": "682200 - 地產保養管理服務",
  "industry_682900": "682900 - 其他地產服務",
  "industry_691100": "691100 - 事務律師法律服務",
  "industry_691200": "691200 - 大律師法律服務",
  "industry_692100": "692100 - 會計及核數服務",
  "industry_692200": "692200 - 簿記及一般會計服務",
  "industry_701100": "701100 - 本地企業管理總辦事處",
  "industry_701200": "701200 - 在境外營運的企業地區總辦事處",
  "industry_702100": "702100 - 公共關係服務",
  "industry_702200": "702200 - 商業管理及顧問服務",
  "industry_711100": "711100 - 建築設計服務",
  "industry_711200": "711200 - 與建造及地產相關的測量服務",
  "industry_711300": "711300 - 結構工程服務",
  "industry_711400": "711400 - 屋宇設備工程服務",
  "industry_711500": "711500 - 土木及土力工程服務",
  "industry_711600": "711600 - 環境工程服務及相關顧問服務",
  "industry_711700": "711700 - 城市規劃及設計活動",
  "industry_711900": "711900 - 綜合及其他與建造相關的建築、測量及工程服務",
  "industry_712000": "712000 - 技術測試及分析",
  "industry_719000": "719000 - 其他與建造及地產活動無關的工程、技術及顧問服務",
  "industry_721000": "721000 - 自然科學及工程學研究及發展",
  "industry_722000": "722000 - 社會科學及人文科學研究及發展",
  "industry_729000": "729000 - 綜合及雜項研究及發展服務",
  "industry_730000": "730000 - 獸醫活動",
  "industry_741100": "741100 - 廣告公司及代理",
  "industry_741900": "741900 - 其他廣告服務",
  "industry_742000": "742000 - 市場研究及民意調查服務",
  "industry_751100": "751100 - 室內及傢具設計服務",
  "industry_751200": "751200 - 多媒體、視覺及平面設計活動",
  "industry_751300": "751300 - 時裝設計服務(包括配飾)",
  "industry_751400": "751400 - 工業設計服務",
  "industry_751900": "751900 - 其他專門設計活動",
  "industry_752100": "752100 - 拍攝服務",
  "industry_752200": "752200 - 相片沖印及修整服務",
  "industry_753000": "753000 - 翻譯及傳譯服務",
  "industry_759000": "759000 - 其他雜項專業、科學及技術活動",
  "industry_771000": "771000 - 機械設備租賃",
  "industry_772100": "772100 - 康樂及運動用品租賃",
  "industry_772200": "772200 - 錄影帶及光碟租賃",
  "industry_772900": "772900 - 其他個人及家庭用品租賃",
  "industry_773000": "773000 - 知識產權及相類非金融無形資產的租賃(版權產品除外)",
  "industry_781000": "781000 - 職業介紹代理活動",
  "industry_782000": "782000 - 臨時人力供應服務",
  "industry_783000": "783000 - 人力資源管理服務",
  "industry_791000": "791000 - 旅行代理活動",
  "industry_799000": "799000 - 其他代訂服務及旅遊相關活動",
  "industry_801000": "801000 - 人身財物護衛服務",
  "industry_802000": "802000 - 保安系統操控服務",
  "industry_803000": "803000 - 私家偵探服務",
  "industry_811000": "811000 - 病媒防治服務",
  "industry_812100": "812100 - 一般樓房清潔服務",
  "industry_812900": "812900 - 其他樓房及工業清潔活動",
  "industry_813000": "813000 - 園境護理及綠化服務",
  "industry_821100": "821100 - 綜合辦公室行政服務活動",
  "industry_821900": "821900 - 影印、文件準備及其他專門辦公室支援活動",
  "industry_822000": "822000 - 電話服務中心活動",
  "industry_823000": "823000 - 會議及商展籌組服務",
  "industry_829100": "829100 - 代收帳款及信貸報告服務",
  "industry_829200": "829200 - 包裝活動",
  "industry_829300": "829300 - 印務代理",
  "industry_829400": "829400 - 藝人、運動員、模特兒及其他公眾人物代理",
  "industry_829900": "829900 - 其他雜項業務支援服務活動",
  "industry_841000": "841000 - 政府行政；經濟及社會政策",
  "industry_842000": "842000 - 公共秩序及安全活動",
  "industry_851100": "851100 - 幼稚園",
  "industry_851200": "851200 - 小學",
  "industry_852000": "852000 - 中學",
  "industry_853000": "853000 - 大學及提供專上課程的院校",
  "industry_854101": "854101 - 球類技巧訓練",
  "industry_854102": "854102 - 田徑技巧訓練",
  "industry_854103": "854103 - 游泳拯溺訓練",
  "industry_854104": "854104 - 瑜伽及健身訓練",
  "industry_854105": "854105 - 武術及太極訓練",
  "industry_854106": "854106 - 風帆、帆船及划艇技巧訓練",
  "industry_854107": "854107 - 野外技巧及山藝訓練",
  "industry_854108": "854108 - 溜冰及滾軸溜冰訓練",
  "industry_854111": "854111 - 騎術訓練",
  "industry_854112": "854112 - 綜合運動技巧訓練",
  "industry_854199": "854199 - 其他運動技巧訓練",
  "industry_854201": "854201 - 戲劇訓練",
  "industry_854202": "854202 - 音樂訓練",
  "industry_854203": "854203 - 舞蹈訓練",
  "industry_854204": "854204 - 繪畫教學",
  "industry_854205": "854205 - 雕塑教學",
  "industry_854206": "854206 - 書法教學",
  "industry_854207": "854207 - 攝影教學",
  "industry_854208": "854208 - 綜合美術及表演藝術學校(學術除外)",
  "industry_854299": "854299 - 其他文化教育",
  "industry_854300": "854300 - 特殊教育",
  "industry_854400": "854400 - 學科補習服務",
  "industry_854901": "854901 - 汽車駕駛訓練",
  "industry_854902": "854902 - 電腦應用訓練",
  "industry_854903": "854903 - 語文訓練",
  "industry_854904": "854904 - 工商科職業先修學校",
  "industry_854905": "854905 - 烹飪訓練",
  "industry_854999": "854999 - 其他雜項教育",
  "industry_855000": "855000 - 教育輔助服務",
  "industry_861100": "861100 - 醫院",
  "industry_861200": "861200 - 留產院",
  "industry_862100": "862100 - 診所",
  "industry_862200": "862200 - 執業醫生醫務所",
  "industry_862300": "862300 - 牙醫執業活動",
  "industry_869100": "869100 - 醫療及X光化驗所",
  "industry_869200": "869200 - 醫療輔助人員執業活動",
  "industry_869300": "869300 - 執業中醫",
  "industry_869900": "869900 - 其他雜項人類保健服務",
  "industry_871100": "871100 - 長者護養院",
  "industry_871900": "871900 - 其他護養院",
  "industry_872000": "872000 - 藥物濫用者住宿照顧活動",
  "industry_873000": "873000 - 長者住宿照顧活動",
  "industry_874000": "874000 - 殘疾人士住宿照顧活動",
  "industry_879000": "879000 - 其他住宿照顧活動",
  "industry_881000": "881000 - 不提供住宿的老人社會工作活動",
  "industry_882000": "882000 - 不提供住宿的殘疾人士社會工作活動",
  "industry_883000": "883000 - 青少年服務中心",
  "industry_884000": "884000 - 兒童日託中心",
  "industry_885000": "885000 - 福利基金及發展計劃服務",
  "industry_889000": "889000 - 其他不提供住宿的社會工作活動",
  "industry_901000": "901000 - 表演藝術活動",
  "industry_902000": "902000 - 藝術創作人、音樂人及作家",
  "industry_903000": "903000 - 表演藝術場所經營",
  "industry_910100": "910100 - 圖書館及檔案保存活動",
  "industry_910200": "910200 - 博物館活動及歷史遺址經營管理",
  "industry_910300": "910300 - 動植物園及自然生態保護活動",
  "industry_920000": "920000 - 遊樂園及主題樂園活動",
  "industry_931101": "931101 - 桌球中心",
  "industry_931102": "931102 - 保齡球中心",
  "industry_931103": "931103 - 游泳池",
  "industry_931104": "931104 - 溜冰場",
  "industry_931105": "931105 - 體操及健身中心",
  "industry_931106": "931106 - 高爾夫球場",
  "industry_931107": "931107 - 網球場館",
  "industry_931108": "931108 - 足球及田徑場",
  "industry_931111": "931111 - 綜合運動場館",
  "industry_931199": "931199 - 其他體育設施運作經營",
  "industry_931200": "931200 - 體育俱樂部活動",
  "industry_931900": "931900 - 其他體育活動",
  "industry_939100": "939100 - 博彩活動",
  "industry_939200": "939200 - 夜總會及舞廳",
  "industry_939300": "939300 - 卡拉OK",
  "industry_939400": "939400 - 的士高",
  "industry_939500": "939500 - 遊戲機中心",
  "industry_939900": "939900 - 其他雜項娛樂活動",
  "industry_941100": "941100 - 企業及僱主會員制組織活動",
  "industry_941200": "941200 - 專業會員制組織活動",
  "industry_942000": "942000 - 工會活動",
  "industry_943000": "943000 - 宗教組織活動",
  "industry_944000": "944000 - 政治組織活動",
  "industry_949000": "949000 - 其他會員制組織活動",
  "industry_951000": "951000 - 汽車及電單車維修服務",
  "industry_952100": "952100 - 電腦及週邊設備修理",
  "industry_952200": "952200 - 通訊設備修理",
  "industry_953100": "953100 - 視聽電子產品修理",
  "industry_953200": "953200 - 家用器具及庭園設備修理",
  "industry_953300": "953300 - 鞋類及皮革製品修補",
  "industry_953400": "953400 - 傢具及室內陳設品修理",
  "industry_953500": "953500 - 鎖匠服務",
  "industry_953600": "953600 - 鐘錶修理",
  "industry_953700": "953700 - 珠寶修理",
  "industry_953900": "953900 - 其他個人及家庭用品修理",
  "industry_960100": "960100 - 洗滌及乾洗服務",
  "industry_960201": "960201 - 理髮服務",
  "industry_960202": "960202 - 化妝、皮膚及面部護理服務",
  "industry_960203": "960203 - 體重控制及纖體服務",
  "industry_960299": "960299 - 其他美容及美體護理",
  "industry_960300": "960300 - 浴室服務",
  "industry_960401": "960401 - 身體按摩服務",
  "industry_960402": "960402 - 足底按摩",
  "industry_960500": "960500 - 堪輿、運程卜算及靈異服務",
  "industry_960600": "960600 - 徵友配對、月老及婚姻禮儀服務",
  "industry_960700": "960700 - 寵物及動物的照顧及馴訓服務",
  "industry_960800": "960800 - 殮葬及相關活動",
  "industry_960900": "960900 - 其他雜項個人服務活動",
  "industry_970000": "970000 - 受聘於住戶的家居活動",
  "industry_980000": "980000 - 用以自給的私人家庭商品及勞務生產活動",
  "industry_990000": "990000 - 享有治外法權的組織及團體活動",
  "industry_OTHER_INSTITUTION": "其他机构（请填写）",
};
